import React from "react";

export default class LoadingOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show,
    };
    this.timer = null;
  }

  syncBodyScroll = (show) => {
    document.body.style.overflow = show ? "hidden" : "auto";
  };

  componentDidMount() {
    this.syncBodyScroll(this.state.show);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.show !== this.props.show && this.props.show) {
      clearTimeout(this.timer);
      this.setState({ show: true });
    }

    if (prevProps.show === true && this.props.show === false) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.setState({ show: false }), 600);
    }

    if (prevState.show !== this.state.show || prevProps.show !== this.props.show) {
      this.syncBodyScroll(this.state.show);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    this.syncBodyScroll(false);
  }

  render() {
    if (!this.state.show) return null;

    return (
      <div className="loading-overlay" aria-live="polite" aria-busy="true">
        <div className="spinner-dot" />
        <div className="spinner-dot" />
        <div className="spinner-dot" />
        <div className="spinner-dot" />
        <div className="spinner-dot" />
        <div className="spinner-dot" />
        <div className="spinner-dot" />
      </div>
    );
  }
}
